/**
 * Toplist Expandable (CDN-1931)
 *
 * Two independent behaviours, both vanilla and idempotent:
 *   A. Per-card details toggle (.toplist-expandable__toggle) — reveals/hides the
 *      aria-controls target, flips aria-expanded + the --expanded card modifier
 *      (chevron rotation is CSS), and swaps the label text.
 *   B. List view-more (.toplist-expandable__view-more) — reveals hidden cards in
 *      data-step batches; once everything is shown it flips to a "less" state
 *      that re-hides past data-initial and scrolls back to the block top.
 *      Mirrors assets/src/js/toplist-v2-view-more.js, scoped to this block.
 */
(function () {
  var BLOCK = 'toplist-expandable';
  var CARD_CLASS = BLOCK + '__card';
  var HIDDEN_CLASS = CARD_CLASS + '--hidden';
  var EXPANDED_CLASS = CARD_CLASS + '--expanded';

  // -------------------------------------------------------------------------
  // A. Per-card details toggle (event delegation — handles any instance count).
  // -------------------------------------------------------------------------
  function onToggleClick(e) {
    var toggle = e.target.closest('.' + BLOCK + '__toggle');
    if (!toggle) return;

    var card = toggle.closest('.' + CARD_CLASS);
    var targetId = toggle.getAttribute('aria-controls');
    var details = targetId ? document.getElementById(targetId) : null;
    var willExpand = toggle.getAttribute('aria-expanded') !== 'true';

    toggle.setAttribute('aria-expanded', willExpand ? 'true' : 'false');

    if (details) {
      details.hidden = !willExpand;
    }

    if (card) {
      card.classList.toggle(EXPANDED_CLASS, willExpand);
    }

    var label = toggle.querySelector('.' + BLOCK + '__toggle-label');
    if (label) {
      var more = toggle.getAttribute('data-show-more') || label.textContent;
      var less = toggle.getAttribute('data-show-less') || label.textContent;
      label.textContent = willExpand ? less : more;
    }
  }

  // -------------------------------------------------------------------------
  // B. List view-more.
  // -------------------------------------------------------------------------
  function initViewMore(btn) {
    if (btn.dataset.tleInit === '1') return;
    btn.dataset.tleInit = '1';

    var block = btn.closest('.' + BLOCK) || btn.parentElement;
    if (!block) return;

    var initial = parseInt(btn.dataset.initial, 10) || 5;
    var step = parseInt(btn.dataset.step, 10) || initial;
    var moreText = btn.dataset.moreText || btn.textContent.trim();
    var lessText = btn.dataset.lessText || btn.textContent.trim();

    function getCards() {
      return block.querySelectorAll('.' + CARD_CLASS);
    }

    function getVisibleCount() {
      var count = 0;
      getCards().forEach(function (card) {
        if (!card.classList.contains(HIDDEN_CLASS)) count++;
      });
      return count;
    }

    function update() {
      var cards = getCards();
      var isFullyExpanded = getVisibleCount() >= cards.length;

      btn.textContent = isFullyExpanded ? lessText : moreText;
      btn.dataset.state = isFullyExpanded ? 'less' : 'more';
      btn.setAttribute('aria-expanded', isFullyExpanded ? 'true' : 'false');
      btn.style.display = cards.length <= initial ? 'none' : '';
    }

    btn.addEventListener('click', function () {
      var cards = getCards();

      if (btn.dataset.state === 'more') {
        var shown = 0;
        cards.forEach(function (card) {
          if (shown >= step) return;
          if (card.classList.contains(HIDDEN_CLASS)) {
            card.classList.remove(HIDDEN_CLASS);
            shown++;
          }
        });
      } else {
        cards.forEach(function (card, i) {
          if (i >= initial) {
            card.classList.add(HIDDEN_CLASS);
          } else {
            card.classList.remove(HIDDEN_CLASS);
          }
        });
        // Collapsing can leave the viewport far below the list — return to it.
        block.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      update();
    });

    update();
  }

  function init() {
    if (!document.body.dataset.tleToggleBound) {
      document.body.dataset.tleToggleBound = '1';
      document.addEventListener('click', onToggleClick);
    }

    document
      .querySelectorAll('.' + BLOCK + '__view-more')
      .forEach(initViewMore);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
